module.exports = __webpack_public_path__ + "assets/img/white-customer-2.178dcb04.png";